"use client";

import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { useRouter } from "next/navigation";

// Overlay + search directory load on first open; see GlobalCommandPaletteDialog.
const GlobalCommandPaletteDialog = dynamic(() => import("./GlobalCommandPaletteDialog"), {
  ssr: false,
});

export default function GlobalCommandPalette() {
  const [isOpen, setIsOpen] = useState(false);
  const [query, setQuery] = useState("");
  const router = useRouter();

  useEffect(() => {
    function handleKeyDown(e: KeyboardEvent) {
      if ((e.metaKey || e.ctrlKey) && e.key.toLowerCase() === "k") {
        e.preventDefault();
        setIsOpen((prev) => !prev);
      }
      if (e.key === "Escape") {
        setIsOpen(false);
      }
    }
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, []);

  const handleSelect = (href: string) => {
    setIsOpen(false);
    setQuery("");
    router.push(href);
  };

  return (
    <>
      {/* Search trigger button in header */}
      <button
        type="button"
        onClick={() => setIsOpen(true)}
        className="inline-flex items-center gap-1.5 rounded-lg border border-border-default bg-surface-warm px-2.5 py-1.5 text-caption text-text-secondary hover:border-border-interactive hover:text-text-primary transition"
        aria-label="Quick search (⌘K)"
      >
        <span className="text-body-small">🔍</span>
        <span className="hidden sm:inline font-medium">Search tools...</span>
        <kbd className="hidden sm:inline-block rounded border border-border-default bg-surface-raised px-1.5 py-0.5 text-caption font-mono text-text-muted">
          ⌘K
        </kbd>
      </button>

      {/* Modal Overlay (lazy chunk; never part of the server HTML) */}
      {isOpen && (
        <GlobalCommandPaletteDialog
          query={query}
          onQueryChange={setQuery}
          onClose={() => setIsOpen(false)}
          onSelect={handleSelect}
        />
      )}
    </>
  );
}
